import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

import { useToast } from '@shared/lib/ui/components-alpha';

export const ProviderAppQueryClient = (props: { children: React.ReactNode }) => {
  const toast = useToast();
  const queryClient = React.useState(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
        },
      },
      queryCache: new QueryCache({
        onError: (error, query) => {
          if (query.meta?.toastError) {
            const message =
              typeof query.meta.toastError === `function` ? query.meta.toastError(error) : query.meta.toastError;
            if (message) {
              toast.addToast({
                message,
                type: 'error',
              });
            }
          }
        },
      }),
      mutationCache: new MutationCache({
        onError: (error, _variables, _context, mutation) => {
          if (mutation.meta?.toastError) {
            const message =
              typeof mutation.meta.toastError === `function`
                ? mutation.meta.toastError(error)
                : mutation.meta.toastError;
            if (message) {
              toast.addToast({
                message,
                type: 'error',
              });
            }
          }
        },
      }),
    });
  })[0];
  return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
};
